var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lease-dashboard" }, [
    _c(
      "div",
      { staticClass: "tab-switcher" },
      _vm._l(_vm.tabs, function (tab) {
        return _c(
          "button",
          {
            key: tab.key,
            class: ["tab-btn", { active: _vm.activeTab === tab.key }],
            on: {
              click: function ($event) {
                return _vm.switchTab(tab.key)
              },
            },
          },
          [_vm._v("\n        " + _vm._s(tab.name) + "\n      ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "stat-cards" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-title" }, [_vm._v("订单总数")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-value" }, [
          _vm._v(_vm._s(_vm.stats.totalOrder)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-title" }, [_vm._v("租赁总收入")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-value" }, [
          _vm._v("¥" + _vm._s(_vm.formatNumber(_vm.stats.totalIncome))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-title" }, [_vm._v("押金总额")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-value" }, [
          _vm._v("¥" + _vm._s(_vm.formatNumber(_vm.stats.totalDeposit))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-title" }, [_vm._v("超期订单数")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-value" }, [
          _vm._v(_vm._s(_vm.stats.overdueOrder)),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "charts-container" }, [
      _c("div", { staticClass: "chart-item" }, [
        _c("h3", [_vm._v("租赁订单趋势")]),
        _vm._v(" "),
        _c("div", { ref: "trendChart", staticClass: "chart" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chart-item" }, [
        _c("h3", [_vm._v("订单状态分布")]),
        _vm._v(" "),
        _c("div", { ref: "statusChart", staticClass: "chart" }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "order-list" }, [
      _c("h3", [_vm._v("最新租赁订单")]),
      _vm._v(" "),
      _c("table", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.latestOrders, function (order) {
            return _c("tr", { key: order.id }, [
              _c("td", [_vm._v(_vm._s(order.id))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(order.user_id))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(order.create_time))]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(order.start_date) + " 至 " + _vm._s(order.end_date)
                ),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(order.days) + "天")]),
              _vm._v(" "),
              _c("td", [
                _vm._v("¥" + _vm._s(_vm.formatNumber(order.total_price))),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            " + _vm._s(order.lease_status) + "\n          "
                ),
              ]),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("订单ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("用户昵称")]),
        _vm._v(" "),
        _c("th", [_vm._v("订单创建时间")]),
        _vm._v(" "),
        _c("th", [_vm._v("租赁时间")]),
        _vm._v(" "),
        _c("th", [_vm._v("租赁天数")]),
        _vm._v(" "),
        _c("th", [_vm._v("订单金额")]),
        _vm._v(" "),
        _c("th", [_vm._v("订单状态")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }